import { StaticVideo } from "types/working-model";

export const isMuxUrl = (video: string | StaticVideo | undefined) => {
	let url = '';
	if (typeof video === 'string') {
		url = video;
	} else {
		if (video?.playback_url) {
			url = video.playback_url;
		}
		if (video?.source) {
			url += video.source;
		}
	}

	return url.includes('mux.com')
		|| url.includes('videodelivery.brandlive');

};